module.exports = __webpack_public_path__ + "static/media/Michael J Fox Foundation for Parkinson.f4191feb.png";